import {errorImg,successImg,signingImg,walletImg,connectingImg} from "assets/lottie"
export const walletErrorImage = errorImg
export const walletConnectedImage = successImg
export const walletConnectingImage = connectingImg
export const walletConnectImage = walletImg
export const walletSigningImage = signingImg